<template>
  <BInput
    v-model="localValue"
    class="ls-top-level-search-input"
    :custom-class="greenLine ? 'green-line' : ''"
    placeholder="Search"
    icon="magnify"
    test-id="ls-top-level-search-input"
    :icon-right="localValue.length ? 'cancel' : ''"
    icon-right-clickable
    type="search"
    @icon-right-click="localValue = ''"
  />
</template>

<script>
import VueTypes from 'vue-types';
import { lsTrackingService, lsPropTypeHelpers } from 'ls-vue-common';

export default {
  name: 'LsTopLevelSearchInput',
  props: {
    value: VueTypes.string.isRequired,
    greenLine: VueTypes.bool.def(false),
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);

        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
      },
    },
  },
};
</script>

<style lang="scss">
.ls-top-level-search-input {
  .input {
    border-width: 0 0 1px 0;
    background-color: transparent;
    box-shadow: none;
    border-color: $gray-primary;
    font-size: $size-4;

    &.green-line {
      border-color: $primary;
    }
  }

  .input::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  .mdi-cancel {
    content: url(assets/cancel.svg);
    transform: rotate(45deg);
    cursor: pointer;
  }

  .mdi-magnify::after {
    content: url(assets/magnify.svg);
    position: absolute;
    top: 7px;
    left: 7px;
  }
}

.themed-app {
  .ls-top-level-search-input {
    .input {
      border-color: $theme-color-gray-darker;
    }

    &.green-line {
      border-color: $theme-color-primary;
    }

    .mdi-cancel {
      background-color: $theme-color-primary;
      content: '';
      height: 19px;
      mask: url(assets/cancel.svg);
      width: 19px;
    }

    .mdi-magnify::after {
      background-color: $theme-color-primary;
      content: '';
      height: 21px;
      mask: url(assets/magnify.svg);
      width: 21px;
    }
  }
}
</style>
